(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gs-contact-accordion"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sectionSelector = "gs-contact-accordions";
  const containerSelector = "gs-contact-accordion";
  const toggleSelector = "gs-contact-accordion__head";
  const bodySelector = "gs-contact-accordion__body";

  // Track all active ResizeObservers to avoid duplicates
  const observers = new WeakMap();

  const openAccordion = (accordion) => {
    const alreadyExpanded = accordion.classList.contains('active');
    const accordionBody = accordion.querySelector(`.${bodySelector}`);

    // Close all accordions and disconnect their observers
    for (const element of document.querySelectorAll(`.${sectionSelector} .${containerSelector}`)) {
      element.querySelector(`.${bodySelector}`).style.maxHeight = '0px';
      element.classList.remove('active');

      if (observers.has(element)) {
        observers.get(element).disconnect();
        observers.delete(element);
      }
    }

    if (alreadyExpanded) return;

    accordion.classList.add('active');
    accordionBody.style.maxHeight = 'none';  // ← changed: no max height when open

  };

  const initAccordions = () => {
    for (const accordion of document.querySelectorAll(`.${sectionSelector} .${containerSelector}`)) {
      // Remove old listener by cloning the toggle element
      const toggle = accordion.querySelector(`.${toggleSelector}`);
      const newToggle = toggle.cloneNode(true);
      toggle.replaceWith(newToggle);

      newToggle.addEventListener('click', () => openAccordion(accordion));
    }
  };

  initAccordions();

  // For Shopify Theme Editor (live preview updates)
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches(`.${sectionSelector}`)) {
      initAccordions();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-contact-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = "gs-contact-faqs-section";
    const containerSelector = "gs-contact-faq";
    const toggleSelector = "gs-contact-faq__head";
    const bodySelector = "gs-contact-faq__body";
  
    const openAccordion = (faq) => {
      const alreadyExpanded = faq.classList.contains('active');
      const faqBody = faq.querySelector(`.${bodySelector}`);
      
      for(const element of document.querySelectorAll(`.${sectionSelector} .${containerSelector}`)) {
        element.querySelector(`.${bodySelector}`).style.maxHeight = '0px';
        element.classList.remove('active');
      }
  
      if(alreadyExpanded) return;
  
      faq.classList.add('active');
      faqBody.style.maxHeight = `${faqBody.scrollHeight}px`;
    }
  
    for(const faq of document.querySelectorAll(`.${sectionSelector} .${containerSelector}`)) {
      faq.querySelector(`.${toggleSelector}`).addEventListener('click', function () {
        openAccordion(faq);
      })
    }
  
    // For Shopify Theme Editor (live preview updates)
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.matches(`.${sectionSelector}`)) {
        for(const faq of document.querySelectorAll(`.${sectionSelector} .${containerSelector}`)) {
          faq.querySelector(`.${toggleSelector}`).addEventListener('click', function () {
            openAccordion(faq);
          })
        }
      }
    });
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const megaMenuTopLevelItems = document.querySelectorAll('details.mega-menu');

    /**
      * @param addClass { boolean } - Whether to add or remove the active class from the element
      */
    const toggleActiveClassOnHeader = (addClass = true) => {
      const header = document.querySelector('header.header');
      
      if(addClass) header.classList.add('active');
      else header.classList.remove('active');
    }

    const toggleMegaMenu = (item, open = true) => {
      const summary = item.querySelector('summary.header__menu-item');

      if(open) {
        item.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      } else {
        item.removeAttribute('open');
        summary.removeAttribute('aria-expanded');
      }
    }

    const toggleMegaMenuInner = (item, open = true) => {
      for(const child of item.parentElement.children) {
        child.classList.remove('active');
      }

      if (open) item.setAttribute('class', `${item.getAttribute('class') ?? ''} active`);
    }
    
    for(const item of megaMenuTopLevelItems) {
      const subMenuItems = item.querySelectorAll('.mega-menu__list > li');

      item.addEventListener('mouseover', () => {
        toggleActiveClassOnHeader(true);
        toggleMegaMenu(item, true);
      });

      item.addEventListener('mouseout', () => {
        toggleActiveClassOnHeader(false);
        toggleMegaMenu(item, false);
      });

      for(const subItem of subMenuItems) {
        if(!subItem.classList) subItem.setAttribute('class', '');
  
        subItem.addEventListener('mouseover', () => {
          toggleMegaMenuInner(subItem, true);
        });
  
        /** subItem.addEventListener('mouseout', () => {
          toggleMegaMenuInner(subItem, false);
        }); **/      
      }
    }
  })()
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["share-current-page"] && !Shopify.designMode) return;
  try {
    
  function copyShareLink(url) {
    navigator.clipboard.writeText(url).then(() => {
      alert('Link copied to clipboard!');
    }, () => {
      alert('Failed to copy link.');
    });
  }

  } catch(e) { console.error(e); }
})();
})();
